module.exports = __webpack_public_path__ + "img/mq.e53fba45.png";